import React from "react";
import styled from "styled-components";
import { Item } from "../../models/item";
import { Readmore } from "./Readmore";

const ReadmoreCard = styled.div`
    background: #fff;
    border-radius: 4px;
    margin: 32px 6px 0;
`;

export const MobileReadmoreCard = ({ item }: { item: Item }) => {
    return (
        <ReadmoreCard>
            <Readmore item={item} />
        </ReadmoreCard>
    );
};
